import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-custom-testing-procedures-dialog.controller';
import template from './edit-custom-testing-procedures-dialog.html';


class dialogService {
  getOptions($event, { assessmentId, procedures }) {
    return {
      controller,
      controllerAs: 'editCustomTestingProceduresDialogVM',
      locals: {
        assessmentId,
        procedures
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editCustomTestingProceduresDialog', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('editCustomTestingProceduresDialog', dialogService)
  .name;
